/** * A method to change the order of elements shown on table */ 
export const sortByKey = <T>(array: T[], key: keyof T, asc: boolean = true): T[] => {
    const orderedArray =  array.sort((a, b) => 
        asc 
            ? String(a[key]).localeCompare(String(b[key])) 
            : String(b[key]).localeCompare(String(a[key]))
    ); 
    
    return orderedArray;
}